import React, { FC, useEffect, useState } from "react";
import { useDispatch, useSelector }       from "react-redux";
import { Button, Icon, Message }          from "semantic-ui-react";
import CheckStaffLimit                    from "../../../application/usecase/staff/CheckStaffLimit";
import Staffs                             from "../../../domain/staff/Staffs";
import { ResKaState }                     from "../../../index";
import RouterDispatcher                   from "../../../infrastructure/redux/router/RouterDispatcher";

const StaffRegisterButton: FC = () => {
  const [limit, setLimit] = useState(true);
  const staffs: Staffs = useSelector((state: ResKaState) => state.staffs);
  const routerDispatcher: RouterDispatcher = new RouterDispatcher(useDispatch());
  const checkStaffLimit: CheckStaffLimit = new CheckStaffLimit(useDispatch());

  useEffect(() => {
    checkStaffLimit.execute(setLimit);
  }, [staffs]);

  if (limit) {
    return (
      <>
        <Message error>
          <Message.Header>スタッフの作成上限に達しました。</Message.Header>
          <p>
            ご契約中のプランでは、これ以上スタッフを作成することができません。<br/>
            プランの変更をご希望の場合は <strong>sales@marespera.co.jp</strong> までご連絡ください。
          </p>
        </Message>
      </>
    );
  }

  return (
    <>
      <Button
        icon
        labelPosition="left"
        onClick={ () => routerDispatcher.staffRegister() }
      >
        <Icon name="plus"/>スタッフのアカウントを作成する
      </Button>
    </>
  );
};

export default StaffRegisterButton;
